import { useCallback } from 'react';
import { isEmpty } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { COMPANY_ACTION_QUERY_PARAM } from 'common/constants/pageActions';
import { TAB_QUERY_PARAM } from 'pages/ValuationsAllocation/common/constants/valuations';

const useTabQueryParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabId = searchParams.get(TAB_QUERY_PARAM);

  const setApproachQueryParam = useCallback(
    (id: string) => {
      if (!isEmpty(id) && tabId !== id) {
        setSearchParams(currentSearchParams => {
          const nextSearchParams = new URLSearchParams(currentSearchParams);
          nextSearchParams.set(TAB_QUERY_PARAM, id);
          // Tab changes may run after a transient page action has been consumed.
          nextSearchParams.delete(COMPANY_ACTION_QUERY_PARAM);
          return nextSearchParams;
        });
      }
    },
    [setSearchParams, tabId]
  );

  return {
    tabId,
    setApproachQueryParam,
  };
};

export default useTabQueryParam;
